<div class="popupWrapp">
  <h3>
    <mat-icon (click)="backClick()">arrow_back</mat-icon>
    Material
  </h3>
  <div class="popupCard">
    <div class="searchHeader">
      <form [formGroup]="searchForm">
        <div class="searchWrapp">
          <mat-icon>search</mat-icon>
                    <input id="modules_rfq_materialdropdown_1" type="search" formControlName="searchText" placeholder="Search Material">
        </div>
      </form>
    </div>
    <!-- <p>{{materialsForm.value | json}}</p>   -->
    <div class="popupBody">
      <div
        class="optionWarpp fullWidth"
      >
        <ul class="dropList scroller">
          <li class="checkboxItem" *ngFor="let material of filteredData">
            <mat-checkbox
              [checked]="material.isChecked"
              [(ngModel)]="material.isChecked"
              (change)="handleOthersMaterialInputVisibility(material)"
            >
              {{ material.name }}
            </mat-checkbox>
          </li>
        </ul>
      </div>

      <div class="col-lg-6" *ngIf="isOtherMaterialInputVisible">
        <label>Other Material Details<sup>*</sup></label>
        <mat-form-field appearance="outline">
          <input
            id=""
            matInput
            [(ngModel)] = "otherMaterialValue"
            placeholder="Other Material Details"
            (input)="handleSaveBtn()"
          />
        </mat-form-field>
      </div>

      <!-- <div class="subWarpp">
                <ul class="dropList scroller">
                    <li class="checkboxItem" *ngFor="let grade of  filterItems()[clickedMaterial]?.materialGrade">
                        <mat-checkbox>
                            {{grade.materialGradeName}}
                        </mat-checkbox>
                    </li>
                </ul>
            </div> -->
    </div>
  </div>
  <div class="popupButton">
    <button
      id="modules_rfq_materialdropdown_2"
      mat-button
      color="primary"
      type="button"
      class="btnCustom btn-outline"
      (click)="unCheckAll()"
    >
      Clear
    </button>
    <button
      id="modules_rfq_materialdropdown_3"
      mat-button
      color="primary"
      type="button"
      class="btnCustom btn-primary"
      (click)="getSelected()"
      [disabled]="!isSaveBtnActive"
    >
      Save
    </button>
  </div>
</div>
